'use client'

import { useEffect } from 'react'
import { installDomFailureProbe, startErrorDiagnostics } from '@/lib/clientErrorReport'

// Installed at module load (before hydration) so failures during the first
// commit are caught too. The probe rethrows, it never swallows errors.
installDomFailureProbe()

// Renders nothing. Starts recording translation signals and recent user
// actions so /api/client_error reports can include them.
export default function ErrorDiagnostics() {
    useEffect(() => {
        startErrorDiagnostics()
    }, [])
    return null
}
